import './index.css'
import clsx from 'clsx'

import React, { useContext, useEffect, useRef, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import type { CatalogLink } from 'types/business'
import { ThemeContext, ThemeProvider } from 'contexts/theme'
import Sticky from 'components/ui/sticky'
type Props = {
  avatar: string | null | undefined
  // could be missing
  children: React.ReactNode
  logoPositionOnMobile?: 'left' | 'center'
  textAlign?: 'center'
  sticky?: boolean
  catalogLink?: CatalogLink | null | undefined
}

const getProcessedLogo = logo => {
  return window.host + '/cat/api/backfill?v=1&w=320&h=320&u=' + logo
}

const Logo = ({
  catalogLink,
  avatar,
}: {
  catalogLink?: CatalogLink | null | undefined
  avatar: string
}) => {
  const mqMobile = useMediaQuery({
    maxWidth: 600,
  })
  const image = <img src={mqMobile ? getProcessedLogo(avatar) : avatar} />
  if (catalogLink)
    return (
      <a
        className="public-header__avatar"
        href={catalogLink.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {image}
      </a>
    )
  return <div className="public-header__avatar">{image}</div>
}

const Header = ({
  avatar,
  logoPositionOnMobile,
  children,
  textAlign,
  sticky,
  catalogLink,
}: Props): React.ReactElement<'div'> => {
  const theme = useContext(ThemeContext).theme
  const [stuck, setStuck] = useState(false)
  const headerRef = useRef<HTMLDivElement>(null)
  const content = (
    <>
      {avatar && <Logo catalogLink={catalogLink} avatar={avatar} />}
      {children}
    </>
  )
  useEffect(() => {
    const setHeaderHeight = () => {
      if (
        headerRef.current &&
        headerRef.current.offsetHeight &&
        document.body
      ) {
        const oldStyle = document.body.style.getPropertyValue(
          '--public-header-height',
        )
        const newStyle = `${headerRef.current?.offsetHeight || 0}px`

        if (oldStyle !== newStyle && document.body) {
          document.body.style.setProperty('--public-header-height', newStyle)
        }
      }

      requestAnimationFrame(setHeaderHeight)
    }

    requestAnimationFrame(setHeaderHeight)
  }, [])

  if (!sticky) {
    return (
      <div
        className={clsx('public-section public-header', {
          'public-header--center': logoPositionOnMobile === 'center',
        })}
        style={{
          textAlign,
        }}
      >
        {content}
      </div>
    )
  }

  return (
    <div className="public-header-wrapper">
      <ThemeProvider
        value={{
          theme: (Boolean(theme) && 'dark') || null,
        }}
      >
        <Sticky onStuckChange={setStuck} zIndex={100}>
          <div
            className={clsx('public-section public-header', {
              'public-header--stuck': stuck,
              'public-header--sticky': sticky,
              'public-header--theme-dark': theme === 'dark',
              'public-header--theme-light': theme === 'light',
              'public-header--center': logoPositionOnMobile !== 'left',
            })}
            style={{
              textAlign,
            }}
            ref={headerRef}
          >
            <div className="public-header-container">{content}</div>
          </div>
        </Sticky>
      </ThemeProvider>
    </div>
  )
}

Header.defaultProps = {
  logoPositionOnMobile: 'center',
}
export default Header
